import { EventHint, CaptureContext } from '@sentry/core'
import * as Sentry from '@sentry/react'

export const captureException = (
  error: unknown,
  hint?: EventHint | CaptureContext,
) => {
  Sentry.captureException(error, hint)
}
